import React from "react";
import MarkSheetFormatFive from "./MarkSheetFormatFive";
import MarkSheetFormatFour from "./MarkSheetFormatFour";
import MarkSheetFormatOne from "./MarkSheetFormatOne";
import MarkSheetFormatThree from "./MarkSheetFormatThree";
import MarkSheetFormatTwo from "./MarkSheetFormatTwo";

const MarkSheetSelector = ({ marksheet, ...rest }) => {
  const formatId = Number(marksheet?.report_info?.report_format?.format_id);

  switch (formatId) {
    case 5: // Formative-Summative
      return <MarkSheetFormatFour marksheet={marksheet} {...rest} />;

    case 4: // A-level
      return <MarkSheetFormatTwo marksheet={marksheet} {...rest} />;

    case 2: // Identifier-based
      return <MarkSheetFormatThree marksheet={marksheet} {...rest} />;

    case 3: // Best 8
      return <MarkSheetFormatFive marksheet={marksheet} {...rest} />;

    case 1: // Classic Positioning
    default:
      return <MarkSheetFormatOne marksheet={marksheet} {...rest} />;
  }
};

export default MarkSheetSelector;
